export interface Denominations {
    ron500: number;
    ron200: number;
    ron100: number;
    ron50: number;
    ron10: number;
    ron5: number;
    ron1: number;
    bani50: number;
    bani10: number;
    bani5: number;
    bani1: number;
}

export function calculateDenominationTotal(denominations: Denominations): number {
    const raw =
        denominations.ron500 * 500 +
        denominations.ron200 * 200 +
        denominations.ron100 * 100 +
        denominations.ron50 * 50 +
        denominations.ron10 * 10 +
        denominations.ron5 * 5 +
        denominations.ron1 * 1 +
        denominations.bani50 * 0.5 +
        denominations.bani10 * 0.1 +
        denominations.bani5 * 0.05 +
        denominations.bani1 * 0.01;
    return Math.round(raw * 100) / 100;
}

export const DEFAULT_DENOMINATIONS: Denominations = {
    ron500: 0,
    ron200: 0,
    ron100: 0,
    ron50: 0,
    ron10: 0,
    ron5: 0,
    ron1: 0,
    bani50: 0,
    bani10: 0,
    bani5: 0,
    bani1: 0,
};

export const DENOMINATION_LABELS: Array<{ key: keyof Denominations; value: number; unit: string }> =
    [
        { key: 'ron500', value: 500, unit: 'RON' },
        { key: 'ron200', value: 200, unit: 'RON' },
        { key: 'ron100', value: 100, unit: 'RON' },
        { key: 'ron50', value: 50, unit: 'RON' },
        { key: 'ron10', value: 10, unit: 'RON' },
        { key: 'ron5', value: 5, unit: 'RON' },
        { key: 'ron1', value: 1, unit: 'RON' },
        { key: 'bani50', value: 50, unit: 'bani' },
        { key: 'bani10', value: 10, unit: 'bani' },
        { key: 'bani5', value: 5, unit: 'bani' },
        { key: 'bani1', value: 1, unit: 'bani' },
    ];
